export default __webpack_public_path__ + "static/media/googleCharts.40c7f1e3.png";